<span [ngClass]="indicatorDetails()?.className">
    <vn-icon size="11" [name]="indicatorDetails().icon" />
</span>
